/* eslint-disable no-unused-vars */
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  createContext,
  useRef,
} from 'react';
import { Card, Button, Box, useTheme } from '@material-ui/core';
import { useDispatch, useSelector } from 'dva';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { useLocation, useIntl, history } from 'umi';
import BasicSettings from './components/basic_settings/index';
import ActivityEquity from './components/activity_equity/index';
import NoticeConfiguration from './components/notice_configuration/index';
import AddMarketingStyled from './AddMarketingStyled';
import webStorage from '@/utils/storageManager';
import { SUBACTIVITYTENANTIDS } from '@/constants';
import { validateCouponRules } from '@/utils/validation';

export const Context = createContext({});
const generateUniqueId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
export default (props) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const theme = useTheme();
  const { marketingId, id, opt, sourceOid } = props.location.query || {};
  const location = useLocation();
  const { pathname } = location;
  const childRef = useRef();
  const childRef2 = useRef();
  const saveRef = useRef();
  const loadingEffect = useSelector((state) => state.loading);
  const isLoading =
    loadingEffect.effects['sceneMarketing/handleUpdateSceneMarketing'] ||
    loadingEffect.effects['sceneMarketing/handleAddSceneMarketing'];
  const allLevelMember = [
    {
      code: 0,
      name: '-',
      discountPercent: '',
      pointMultiply: '',
      pointAdd: '',
      coupons: '[]',
      status: 1,
      couponNum: 0,
      level: null,
    },
  ];
  const [selectedNoticeChannels, setSelectedNoticeChannels] = useState([]);
  const [title, setTitle] = useState();
  const [isBirthday, setIsBirthday] = useState(false);
  const [noticeType, setNoticeType] = useState('NOTICE_ONE');
  const [type, setType] = useState();
  const [weChatType, setWeChatType] = useState();
  const [dateType, setDateType] = useState(
    marketingId?.toString() === '1' ? 'BIRTHDAY_DAY' : 'CYCLE_MONTH',
  );
  const [dateCycleBeginDay, setDateCycleBeginDay] = useState();
  const [dateCycleEndDay, setDateCycleEndDay] = useState();
  const [dateFixDay, setDateFixDay] = useState();
  const [dateFixMonth, setDateFixMonth] = useState();
  const [dateBeginTimestamp, setDateBeginTimestamp] = useState();
  const [dateEndTimestamp, setDateEndTimestamp] = useState();
  const [benefitType, setBenefitType] = useState('SAME');
  const [levelRulesList, setLevelRulesList] = useState([]);
  const [allLevelData, setAllLevelData] = useState([]);
  const [hasLevelRule, setHasLevelRule] = useState(false);
  const [hasProductRule, setHasProductRule] = useState(false);
  const [orderBenefitType, setOrderBenefitType] = useState('DESIGNATED_GOODS');
  const [isAllCompany, setIsAllCompany] = useState(true);
  const [isAllStore, setIsAllStore] = useState('IS_ALL_STORE');
  const [stores, setStores] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [productRulesList, setProductRulesList] = useState([]);
  const [orderChannelConditions, setOrderChannelConditions] = useState();
  const [orderChannelIsLimit, setOrderChannelIsLimit] = useState('0');
  const [orderAmountLimit, setOrderAmountLimit] = useState(0);
  // isFirstOrderValid 是否为首单
  const [isFirstOrderValid, setIsFirstOrderValid] = useState('0');
  const [isAllGoods, setIsAllGoods] = useState('ALL_GOODS');
  const [isSubmit, setIsSubmit] = useState(false);
  const [isSave, setIsSave] = useState(false);
  const TENANTID = webStorage.get('TENANT_ID');
  const userAuths = webStorage.get('USER')?.authorities;
  const isMenuEmailMktg = userAuths.includes('MENU_EMAIL_MKTG');
  const [noticePriority, setNoticePriority] = useState([
    {
      sortNo: 1,
      noticeChannelType: 2,
      // 微信模板消息
      noticeChannelName: formatMessage({
        id: 'marketing.scene.holiday.c10.lbl04',
      }),
      show: TENANTID !== '11076',
    },
    {
      sortNo: 2,
      noticeMsgId: '',
      noticeChannelName: '邮件',
      noticeChannelType: '5',
      show: isMenuEmailMktg,
    },
    {
      sortNo: 4,
      noticeChannelType: 1,
      //  短信
      noticeChannelName: formatMessage({
        id: 'marketing.scene.holiday.c10.lbl06',
      }),
      show: TENANTID !== '11076',
    },
    {
      sortNo: 4,
      noticeChannelType: 6,
      //  短信
      noticeChannelName: 'Line 模版消息',
      show: TENANTID === '11076',
    },
  ]);
  let {
    storeName,
    storeCode,
    storeStatus,
    storeType,
    storesPageNum,
    storesPageSize,
  } = useSelector((state) => state.couponsSetting);
  const [isSendCoupon, setIsSendCoupon] = useState(false);
  const [isSendCouponList, setIsSendCouponList] = useState([
    {
      minAmount: 0,
      maxAmount: 0,
      couponInfo: [],
      couponNum: 0,
      id: generateUniqueId(),
    },
  ]);
  const [couponId, setCouponId] = useState('');
  const [ticketList, setTicketList] = useState([]);
  const [ticketListSave, setTicketListSave] = useState([]);
  // 拿到id后调取详情接口
  const getSceneMarketingDetail = useCallback(() => {
    dispatch({
      type: 'sceneMarketing/getSceneMarketingDetail',
      payload: {
        values: {
          id: id,
        },
      },
    });
  }, [dispatch, id]);

  useEffect(() => {
    if (id) {
      getSceneMarketingDetail();
    }
  }, []);

  // 会员等级
  const memberLevel = useSelector(
    (state) => state.sceneMarketing.memberLevel,
  )?.map((item) => ({ code: item.code, name: item.name }));
  const diffMember = useSelector((state) => state.sceneMarketing.diffMember);

  // 活动详情数据
  const sceneMarketingDetail = useSelector(
    (state) => state.sceneMarketing.sceneMarketingDetail,
  );

  // 处理详情页的productRulesList

  useEffect(() => {
    if (id && sceneMarketingDetail) {
      const newArray = sceneMarketingDetail?.noticeChannels?.map((i) => {
        return {
          ...i,
          checked: true,
        };
      });
      setSelectedNoticeChannels(newArray);
      setTitle(sceneMarketingDetail.title);
      setIsBirthday(sceneMarketingDetail?.isBirthday);
      setType(sceneMarketingDetail?.type);
      setDateType(sceneMarketingDetail?.dateType);
      setNoticeType(sceneMarketingDetail?.noticeType);
      setDateCycleBeginDay(sceneMarketingDetail?.dateCycleBeginDay);
      setDateCycleEndDay(sceneMarketingDetail?.dateCycleEndDay);
      setDateFixDay(sceneMarketingDetail?.dateFixDay);
      setDateFixMonth(sceneMarketingDetail?.dateFixMonth);
      setDateBeginTimestamp(sceneMarketingDetail?.dateBeginTimestamp);
      setDateEndTimestamp(sceneMarketingDetail?.dateEndTimestamp);
      setBenefitType(sceneMarketingDetail?.benefitType);
      setLevelRulesList(sceneMarketingDetail?.levelRulesList);
      setHasLevelRule(sceneMarketingDetail?.hasLevelRule);
      setIsSendCoupon(Boolean(sceneMarketingDetail.isSendCoupon));
      setHasProductRule(sceneMarketingDetail?.hasProductRule);
      setOrderBenefitType(sceneMarketingDetail?.orderBenefitType);
      setIsAllCompany(sceneMarketingDetail?.isAllCompany);
      setIsAllStore(sceneMarketingDetail?.isAllStore);
      setStores(sceneMarketingDetail?.stores);
      setCompanies(sceneMarketingDetail?.companies);
      setProductRulesList(sceneMarketingDetail?.productRulesList);
      setIsFirstOrderValid(sceneMarketingDetail?.isFirstOrderValid ? '1' : '0');
      setOrderChannelConditions(sceneMarketingDetail?.orderChannelConditions);
      setOrderChannelIsLimit(String(sceneMarketingDetail?.orderChannelIsLimit));
      setOrderAmountLimit(sceneMarketingDetail?.orderAmountLimit);
      if (location.pathname.includes('repurchase')) {
        const newArr =
          sceneMarketingDetail?.productRulesList?.map((i) => ({
            ...i,
            proNo: i.addTypeName,
          })) || [];
        setTicketList(newArr);
        setTicketListSave(newArr);
        setIsAllGoods(sceneMarketingDetail?.orderBenefitType || 'ALL_GOODS');
      }
      // 全部等级
      if (sceneMarketingDetail.benefitType === 'SAME') {
        setAllLevelData(sceneMarketingDetail?.levelRulesList);
      }
      if (sceneMarketingDetail.sendCouponInfo?.length > 0) {
        const arr = sceneMarketingDetail.sendCouponInfo.map((i) => {
          return {
            ...i,
            couponNum: i.couponInfo.length > 0 ? i.couponInfo[0].givenNum : 0,
            id: generateUniqueId(),
          };
        });
        setIsSendCouponList(arr);
      }
    }
  }, [id, sceneMarketingDetail]);

  useEffect(() => {
    if (marketingId?.toString() === '0') {
      setType('REGISTRATION_ACTIVITY');
      setDateType('REGISTER_DAY');
    }
  }, [marketingId]);

  // type值的设置
  useEffect(() => {
    if (marketingId) {
      if (marketingId?.toString() === '0') {
        setType('REGISTRATION_ACTIVITY');
      }
      if (marketingId?.toString() === '1') {
        setType('BIRTHDAY_ACTIVITY');
      }
      if (marketingId?.toString() === '2') {
        setType('MEMBER_ACTIVITY');
      }
      if (marketingId?.toString() === '3') {
        setType('FESTIVAL_ACTIVITY');
      }
    }
  }, [marketingId]);

  useEffect(() => {
    if (location.pathname.includes('bind')) {
      setType('MEMBER_BINDING_ACTIVITY');
    }
    if (location.pathname.includes('consumption')) {
      setType('CONSUMPTION_ACTIVITY');
    }
    if (location.pathname.includes('level_change')) {
      setType('LEVEL_CHANGE_ACTIVITY');
    }
    if (location.pathname.includes('point_use')) {
      setType('POINT_USED_ACTIVITY');
    }
    if (location.pathname.includes('repurchase')) {
      setType('REPURCHASE_ACTIVITY');
    }
  }, [location]);

  useMemo(() => {
    if (location.pathname.includes('festival')) {
      setWeChatType('FESTIVAL');
    }
    if (location.pathname.includes('registration')) {
      setWeChatType('REGISTER_BINDING');
    }
    if (location.pathname.includes('member')) {
      setWeChatType('MEMBER_DAY');
    }
    if (location.pathname.includes('birthday')) {
      setWeChatType('BIRTHDAY');
    }
    if (location.pathname.includes('bind')) {
      setWeChatType('REGISTER_BINDING');
    }
    if (location.pathname.includes('consumption')) {
      setWeChatType('MEMBER_CONSUMPTION');
    }
    if (location.pathname.includes('level_change')) {
      setWeChatType('LEVEL_POINT');
    }
    if (location.pathname.includes('point_use')) {
      setWeChatType('LEVEL_POINT');
    }
  }, [location]);
  useEffect(() => {
    if (SUBACTIVITYTENANTIDS.includes(TENANTID)) {
      noticePriority.splice(1, 0, {
        sortNo: 3,
        noticeChannelType: 3,
        //  短信
        noticeChannelName: '订阅消息',
        show: true,
      });
      setNoticePriority([...noticePriority]);
    }
  }, [TENANTID]);

  //初始赋值
  const initialFormData = useMemo(() => {
    return {
      title: title,
      isBirthday: isBirthday,
      type: type,
      dateType: dateType,
      noticeType: noticeType,
      dateCycleBeginDay: dateCycleBeginDay,
      dateCycleEndDay: dateCycleEndDay,
      dateFixDay: dateFixDay,
      dateFixMonth: dateFixMonth,
      dateBeginTimestamp: dateBeginTimestamp,
      dateEndTimestamp: dateEndTimestamp,
      benefitType: benefitType,
      // noticeChannels: noticeChannels,
      levelRulesList: levelRulesList,
      hasLevelRule: hasLevelRule,
      isSendCoupon: isSendCoupon,
      hasProductRule: hasProductRule,
      orderBenefitType: orderBenefitType,
      isAllCompany: isAllCompany,
      isAllStore: isAllStore,
      stores: stores,
      companies: companies,
      productRulesList: productRulesList,
      orderChannelConditions: orderChannelConditions,
      orderChannelIsLimit: orderChannelIsLimit,
      isFirstOrderValid: toString(isFirstOrderValid),
      orderAmountLimit: orderAmountLimit,
    };
  }, [
    title,
    isBirthday,
    type,
    dateType,
    noticeType,
    dateCycleBeginDay,
    dateCycleEndDay,
    dateFixDay,
    dateFixMonth,
    dateBeginTimestamp,
    dateEndTimestamp,
    benefitType,
    levelRulesList,
    hasLevelRule,
    hasProductRule,
    orderBenefitType,
    isAllCompany,
    isAllStore,
    stores,
    companies,
    productRulesList,
    isFirstOrderValid,
    orderChannelConditions,
    orderChannelIsLimit,
    orderAmountLimit,
    isSendCoupon,
  ]);
  const handleUpdate = (newArr, newLevel, formData) => {
    const validateResult = validateCouponRules(isSendCouponList);
    if (ticketListSave.length === 0 && isAllGoods !== 'ALL_GOODS') {
      setIsSubmit(false);
      setIsSave(false);
      return window.message.toast({
        type: 'error',
        message: '请选择适用范围',
        title: '请选择适用范围',
      });
    }
    if (!validateResult.valid) {
      setIsSubmit(false);
      setIsSave(false);
      return window.message.toast({
        type: 'error',
        message: validateResult.message,
        title: validateResult.message,
      });
    }
    isSendCouponList.forEach((item) => {
      if (item.couponInfo?.length > 0) {
        item.couponInfo.forEach((i) => {
          i.givenNum = Number(item.couponNum || 0);
        });
      }
    });
    const NoticeChannels = selectedNoticeChannels?.filter((i) => i.checked);
    levelRulesList.forEach((element, index) => {
      if (benefitType === 'NOT_SAME') {
        element['level'] = element['code'];
        if (!element.code) {
          element['level'] = Number(index) + 1;
        }
      }
      if (element?.coupons !== null && Array.isArray(element?.coupons)) {
        const newCoupons = element?.coupons?.map((item) => {
          return {
            id: item.id,
            couponCode: item.couponCode,
            title: item.title,
            isAllGoods: item.isAllGoods,
            subTitle: item.subTitle,
            discountAmount: item.discountAmount,
            discountPercent: item.discountPercent,
            memberLimit: item.memberLimit,
            isLimitMaxCoupons: item.isLimitMaxCoupons,
            surplus: item.surplus,
          };
        });
        element['coupons'] = JSON.stringify(newCoupons);
      }
    });

    const productRulesData = ticketListSave.map((item) => {
      return {
        ...item,
        productNo: item.priceNo,
        addTypeName: item.proNo,
        addType: 'SERIES',
      };
    });

    const values = {
      id: id,
      title: title,
      type: type,
      // 注册营销时为固定值
      dateType: dateType,
      dateBeginTimestamp: dateBeginTimestamp,
      dateEndTimestamp: dateEndTimestamp,
      // 是否设置等级会员 节日营销
      hasLevelRule: location.pathname.includes('repurchase')
        ? true
        : hasLevelRule,
      isSendCoupon: Number(isSendCoupon),
      sendCouponInfo: isSendCouponList,
      noticeType: noticeType,
      dateCycleEndDay: dateCycleEndDay,
      levelRulesList: newLevel?.length > 0 ? newLevel : levelRulesList,
      isBirthday: isBirthday,
      dateFixDay: dateFixDay,
      dateFixMonth: dateFixMonth,
      dateCycleBeginDay: dateCycleBeginDay,
      hasProductRule: location.pathname.includes('repurchase')
        ? true
        : hasProductRule,
      companies: companies,
      isAllCompany: isAllCompany,
      isAllStore: isAllStore,
      benefitType: benefitType,
      noticeChannels: NoticeChannels,
      noticePriority: [
        {
          sortNo: 1,
          noticeChannelType: 2,
          // 微信模板消息
          noticeChannelName: '微信模板消息',
        },
        {
          sortNo: 2,
          noticeChannelName: '邮件',
          noticeChannelType: '5',
        },
        {
          sortNo: 3,
          noticeChannelType: 3,
          //  短信
          noticeChannelName: '订阅消息',
        },
        {
          sortNo: 4,
          noticeChannelType: 1,
          //  短信
          noticeChannelName: '短信',
        },
        {
          sortNo: 4,
          noticeChannelType: 6,
          //  短信
          noticeChannelName: 'Line 模版消息',
        },
      ],
      // noticeTime:'',
      orderBenefitType: location.pathname.includes('repurchase')
        ? isAllGoods
        : orderBenefitType,
      // 商品列表
      productRulesList: location.pathname.includes('repurchase')
        ? productRulesData
        : newArr,
      stores: stores,
      // 是否为首单
      isFirstOrderValid: isFirstOrderValid === '1',
      orderChannelConditions:
        formData?.orderChannelIsLimit === '1'
          ? formData?.orderChannelConditions
          : [],
      orderChannelIsLimit: formData?.orderChannelIsLimit,
      orderAmountLimit: formData?.paidAmountCheckbox
        ? formData?.orderAmountLimit
        : '',
    };
    dispatch({
      type: 'sceneMarketing/handleUpdateSceneMarketing',
      payload: {
        values,
      },
      callback: (res) => {
        window.NE_DAWN.trigger(saveRef.current, {
          event: '_ec', // 事件名
          params: { ...values }, // 事件公参
        });
        if (res.code === 0) {
          window.message.toast({
            type: 'success',
            message: '更新成功',
            title: '更新成功',
          });
          history.goBack();
        } else {
          setIsSubmit(false);
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
        }
      },
    });
  };

  const handleAdd = (newArr, newLevel, formData) => {
    const validateResult = validateCouponRules(isSendCouponList);
    if (ticketListSave.length === 0 && isAllGoods !== 'ALL_GOODS') {
      setIsSubmit(false);
      setIsSave(false);
      return window.message.toast({
        type: 'error',
        message: '请选择适用范围',
        title: '请选择适用范围',
      });
    }
    if (!validateResult.valid) {
      setIsSubmit(false);
      setIsSave(false);
      return window.message.toast({
        type: 'error',
        message: validateResult.message,
        title: validateResult.message,
      });
    }
    isSendCouponList.forEach((item) => {
      if (item.couponInfo?.length > 0) {
        item.couponInfo.forEach((i) => {
          i.givenNum = Number(item.couponNum || 0);
        });
      }
    });
    const NoticeChannels = selectedNoticeChannels?.filter((i) => i.checked);
    levelRulesList.forEach((element, index) => {
      if (benefitType === 'NOT_SAME') {
        element['level'] = element['code'];
        if (!element.code) {
          element['level'] = Number(index) + 1;
        }
      }
      if (element?.coupons !== null && Array.isArray(element?.coupons)) {
        const newCoupons = element?.coupons?.map((item) => {
          return {
            id: item.id,
            couponCode: item.couponCode,
            title: item.title,
            isAllGoods: item.isAllGoods,
            subTitle: item.subTitle,
            discountAmount: item.discountAmount,
            discountPercent: item.discountPercent,
            memberLimit: item.memberLimit,
            isLimitMaxCoupons: item.isLimitMaxCoupons,
            surplus: item.surplus,
          };
        });
        element['coupons'] = JSON.stringify(newCoupons);
      }
    });
    const productRulesData = ticketListSave.map((item) => {
      return {
        ...item,
        productNo: item.priceNo,
        addTypeName: item.proNo,
        addType: 'SERIES',
      };
    });
    const values = {
      title: title,
      type: type,
      // 注册营销时为固定值
      dateType: dateType,
      dateBeginTimestamp: dateBeginTimestamp,
      dateEndTimestamp: dateEndTimestamp,
      // 是否设置等级会员 节日营销
      hasLevelRule: location.pathname.includes('repurchase')
        ? true
        : hasLevelRule,
      isSendCoupon: Number(isSendCoupon),
      sendCouponInfo: isSendCouponList,
      noticeType: noticeType,
      dateCycleEndDay: dateCycleEndDay,
      levelRulesList:
        type === 'REGISTRATION_ACTIVITY' ? levelRulesList : newLevel,
      isBirthday: isBirthday,
      dateFixDay: dateFixDay,
      dateFixMonth: dateFixMonth,
      dateCycleBeginDay: dateCycleBeginDay,
      hasProductRule: location.pathname.includes('repurchase')
        ? true
        : hasProductRule,
      companies: companies,
      isAllCompany: isAllCompany,
      isAllStore: isAllStore,
      benefitType: benefitType,
      noticeChannels: NoticeChannels,
      noticePriority: [
        {
          sortNo: 1,
          noticeChannelType: 2,
          // 微信模板消息
          noticeChannelName: '微信模板消息',
        },
        {
          sortNo: 2,
          noticeChannelName: '邮件',
          noticeChannelType: '5',
        },
        {
          sortNo: 3,
          noticeChannelType: 3,
          //  短信
          noticeChannelName: '订阅消息',
        },
        {
          sortNo: 4,
          noticeChannelType: 1,
          //  短信
          noticeChannelName: '短信',
        },
        {
          sortNo: 4,
          noticeChannelType: 6,
          //  短信
          noticeChannelName: 'Line 模版消息',
        },
      ],
      orderBenefitType: location.pathname.includes('repurchase')
        ? isAllGoods
        : orderBenefitType,
      // 商品列表
      productRulesList: location.pathname.includes('repurchase')
        ? productRulesData
        : newArr,
      stores: stores,
      isFirstOrderValid: isFirstOrderValid === '1',
      orderChannelConditions:
        formData?.orderChannelIsLimit === '1'
          ? formData?.orderChannelConditions
          : [],
      orderChannelIsLimit: formData?.orderChannelIsLimit,
      orderAmountLimit: formData?.paidAmountCheckbox
        ? formData?.orderAmountLimit
        : '',
    };
    dispatch({
      type: 'sceneMarketing/handleAddSceneMarketing',
      payload: {
        values,
      },
      callback: (res) => {
        window.NE_DAWN.trigger(saveRef.current, {
          event: '_ec', // 事件名
          params: { ...values }, // 事件公参
        });
        if (res.code === 0) {
          window.message.toast({
            type: 'success',
            message: '新建成功',
            title: '新建成功',
          });
          history.goBack();
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
          setIsSubmit(false);
        }
      },
    });
  };

  const handleMemberRegistration = (formData) => {
    if (isSave || isSubmit) {
      return false;
    }
    setIsSubmit(true);
    const newArr = [...productRulesList];
    const newLevel = [...(benefitType === 'SAME' ? allLevelData : diffMember)];
    // 选择不同等级时需要传不同等级的数组
    newLevel.forEach((element, index) => {
      if (benefitType === 'NOT_SAME') {
        element['level'] = element['code'];
        if (!element.code) {
          element['level'] = Number(index) + 1;
        }
      }
      if (element?.coupons !== null && Array.isArray(element?.coupons)) {
        const newCoupons = element?.coupons?.map((item) => {
          return {
            id: item.id,
            couponCode: item.couponCode,
            title: item.title,
            isAllGoods: item.isAllGoods,
            subTitle: item.subTitle,
            discountAmount: item.discountAmount,
            discountPercent: item.discountPercent,
            memberLimit: item.memberLimit,
            isLimitMaxCoupons: item.isLimitMaxCoupons,
            surplus: item.surplus,
          };
        });
        element['coupons'] = JSON.stringify(newCoupons);
      }
    });
    if (id) {
      // 更新详情
      handleUpdate(newArr, newLevel, formData);
    } else {
      handleAdd(
        newArr,
        newLevel?.length < 1 ? allLevelMember : newLevel,
        formData,
      );
    }
  };

  const onSubmit = () => {
    console.log('onSubmit');
    setIsSave(false);
    childRef.current.clickInput();
  };

  const handleMemberRegistrationSubmitSuccess = () => {
    childRef2.current.clickInput();
  };

  const getMemberLevel = useCallback(() => {
    dispatch({
      type: 'sceneMarketing/getMemberLevel',
      payload: {},
    });
  }, [dispatch]);

  useEffect(() => {
    getMemberLevel();
  }, [getMemberLevel]);
  // 获取门店列表
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getStores',
      payload: {
        value: {
          name: storeName,
          code: storeCode,
          status: storeStatus,
          type: storeType,
          pageNum: storesPageNum,
          pageSize: storesPageSize,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    storeName,
    storesPageNum,
    storesPageSize,
    storeCode,
    storeStatus,
    storeType,
  ]);

  const handleInitEvent = (value, name) => {
    const regex = /^(min_|max_|couponNum_)(.+)$/;
    let nameId = '';
    let nameType = '';
    const match = name.match(regex);
    if (match && match.length > 2) {
      nameId = match[2];
      nameType = match[1];
    }
    const newArr = [...isSendCouponList];
    const findIndex = newArr.findIndex((item) => item.id === nameId);
    if (nameType === 'min_') {
      newArr[findIndex].minAmount = value;
    } else if (nameType === 'max_') {
      newArr[findIndex].maxAmount = value;
    } else if (nameType === 'couponNum_') {
      newArr[findIndex].couponNum = value;
    }
    setIsSendCouponList(newArr);
  };
  const handleAddCoupon = () => {
    setIsSendCouponList([
      ...isSendCouponList,
      {
        minAmount: 0,
        maxAmount: 0,
        couponInfo: [],
        couponNum: 0,
        id: generateUniqueId(),
      },
    ]);
  };
  const handleSaveCouponList = (data) => {
    const newArr = [...isSendCouponList];
    const findIndex = newArr.findIndex((item) => item.id === couponId);
    newArr[findIndex].couponInfo = data;
    setIsSendCouponList(newArr);
  };
  const handleDeleteCoupon = (nameId) => {
    const newArr = isSendCouponList.filter((item) => item.id !== nameId);
    setIsSendCouponList(newArr);
  };
  return (
    <AddMarketingStyled theme={theme}>
      <Card
        data-log={JSON.stringify({
          oid: 'page_marketing_activity_scene_marketing_edit',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
            source: sourceOid,
          },
          events: ['_pv', '_pd'],
        })}
        className="submit-wrap"
      >
        <Context.Provider
          value={{
            ref: childRef,
          }}
        >
          <BasicSettings
            opt={opt}
            marketingId={marketingId}
            id={id}
            title={initialFormData.title}
            setTitle={setTitle}
            isBirthday={initialFormData.isBirthday}
            type={initialFormData.type}
            dateType={initialFormData.dateType}
            dateCycleBeginDay={initialFormData.dateCycleBeginDay}
            dateCycleEndDay={initialFormData.dateCycleEndDay}
            dateFixDay={initialFormData.dateFixDay}
            dateFixMonth={initialFormData.dateFixMonth}
            dateBeginTimestamp={initialFormData.dateBeginTimestamp}
            dateEndTimestamp={initialFormData.dateEndTimestamp}
            setIsBirthday={setIsBirthday}
            setType={setType}
            setDateCycleBeginDay={setDateCycleBeginDay}
            setDateCycleEndDay={setDateCycleEndDay}
            setDateFixDay={setDateFixDay}
            setDateFixMonth={setDateFixMonth}
            setDateBeginTimestamp={setDateBeginTimestamp}
            setDateEndTimestamp={setDateEndTimestamp}
            setDateType={setDateType}
            handleSubmitSuccess={handleMemberRegistrationSubmitSuccess}
          ></BasicSettings>
        </Context.Provider>
        <Context.Provider
          value={{
            ref: childRef2,
          }}
        >
          <ActivityEquity
            levelRulesList={levelRulesList}
            benefitType={initialFormData.benefitType}
            setBenefitType={setBenefitType}
            setLevelRulesList={setLevelRulesList}
            marketingId={marketingId}
            opt={opt}
            hasLevelRule={hasLevelRule}
            hasProductRule={hasProductRule}
            setHasProductRule={setHasProductRule}
            setHasLevelRule={setHasLevelRule}
            isSendCoupon={isSendCoupon}
            setIsSendCoupon={setIsSendCoupon}
            isSendCouponList={isSendCouponList}
            handleInitEvent={handleInitEvent}
            handleAddCoupon={handleAddCoupon}
            handleSaveCouponList={handleSaveCouponList}
            setCouponId={setCouponId}
            handleDeleteCoupon={handleDeleteCoupon}
            orderBenefitType={orderBenefitType}
            setOrderBenefitType={setOrderBenefitType}
            id={id}
            isAllCompany={initialFormData?.isAllCompany}
            setIsAllCompany={setIsAllCompany}
            isAllStore={isAllStore}
            setIsAllStore={setIsAllStore}
            storesChooseItemShowData={stores}
            setStoresChooseItemShowData={setStores}
            companies={companies}
            setCompanies={setCompanies}
            productRulesList={initialFormData.productRulesList}
            setProductRulesList={setProductRulesList}
            onSubmit={handleMemberRegistration}
            memberLevel={memberLevel}
            allLevelMember={allLevelMember}
            isFirstOrderValid={isFirstOrderValid}
            setIsFirstOrderValid={setIsFirstOrderValid}
            // 全部等级
            allLevelData={allLevelData}
            setAllLevelData={setAllLevelData}
            setIsSave={setIsSave}
            orderChannelConditions={orderChannelConditions}
            orderChannelIsLimit={orderChannelIsLimit}
            orderAmountLimit={orderAmountLimit}
            ticketList={ticketList}
            setTicketList={setTicketList}
            ticketListSave={ticketListSave}
            setTicketListSave={setTicketListSave}
            isAllGoods={isAllGoods}
            setIsAllGoods={setIsAllGoods}
          ></ActivityEquity>
        </Context.Provider>

        <NoticeConfiguration
          opt={opt}
          noticePriority={noticePriority}
          noticeType={initialFormData.noticeType}
          setSelectedNoticeChannels={setSelectedNoticeChannels}
          setNoticeType={setNoticeType}
          marketingId={marketingId}
        ></NoticeConfiguration>
        <Box className="button-group">
          {opt === 'detail' ? (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => history.goBack()}
              startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {/* 退出 */}
              {formatMessage({ id: 'comm.action.btn.16' })}
            </Button>
          ) : (
            <>
              <Button
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_scene_marketing_edit_finish',
                  events: ['_ev'],
                  params: {
                    initUrl: window.location.origin + window.location.pathname,
                    source: sourceOid,
                  },
                })}
                ref={saveRef}
                variant="contained"
                className="search"
                startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
                onClick={() => !isLoading && onSubmit()}
              >
                {/* 完成 */}
                {formatMessage({ id: 'comm.action.btn.17' })}
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => history.goBack()}
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
              >
                {/* 退出 */}
                {formatMessage({ id: 'comm.action.btn.16' })}
              </Button>
            </>
          )}
        </Box>
      </Card>
    </AddMarketingStyled>
  );
};
